// src/redux/rootReducer.js
import { combineReducers } from "redux";
import reducer from "./reducer";

const appReducer = combineReducers({ reducer });

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") state = undefined;
  return appReducer(state, action);
};

export default rootReducer;